import { useState, useEffect } from 'react';
import pageImg from '@/assets/images/default_site.png';
import './style.scss';
const SiteImage = (props) => {
    let default_img = pageImg;
    let { src, errimg, ...otherProps } = props;
    const [imgSrc, setImgSrc] = useState(src || default_img);
    const onError = () => {
        setImgSrc(errimg || default_img);
    };
    useEffect(() => {
        if (!props.src) {
            setImgSrc(default_img);
            return;
        }
    }, [props.src]);
    return (
        <>
            <img className="site-img" {...otherProps} src={imgSrc} onError={onError} alt="" />
        </>
    );
};
export default SiteImage;
